import React, { Component } from 'react'
import { Field, reduxForm, change } from 'redux-form'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'

// COMPONENTS
import { ButtonContained, ButtonOutlined } from '../app-button/button'
import Spinner from '../spinner'
import Typography from '@material-ui/core/Typography'
import renderCheckbox from './field/Checkbox'
import { connect } from 'react-redux'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import Slide from '@material-ui/core/Slide'

const styles = theme => ({
  form: {
    maxWidth: 388,
    width: '100%',
  },
  chip: {
    width: '100%',
    marginBottom: 16,
  },
  root: {
    paddingLeft: 21,
    paddingRight: 3,
    borderRadius: 4,
    height: 48,
    justifyContent: 'flex-start',
  },
  colorSecondary: {
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  deleteIcon: {
    color: '#000',
    marginLeft: 'auto',
    '&:hover': {
      color: '#000',
    },
  },
  label: {
    paddingLeft: 0,
  },
  fieldGroupe: {
    display: 'flex',
  },
  '@keyframes wiggle': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },

  '@keyframes wiggle2': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },

  wiggle: {
    willChange: 'transform',
    animationName: 'wiggle',
    animationDuration: '150ms',
    animationIterationCount: 4,
  },
  crmDescriptionSmall: {
    marginTop: '20px',
    marginBottom: '5px',
    opacity: '0.75',
    fontSize: '12px',
  },
  error: {
    padding: '10px 0',
    fontSize: '12px',
    color: '#ff4e44',
  },
  sendCid: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '15px',
  },
  links: {
    textDecoration: 'underline',
  },
})

function Transition(props) {
  return <Slide direction="up" {...props} />
}

class CallTrackingByForm extends Component {
  state = {
    checkedA: this.props.initialValues
      ? !!this.props.initialValues.agree_null_cid
      : true,
    open: false,
    account: window.state.settings,
  }

  handleClick = (classes, submitFailed) => {
    if (submitFailed) {
      this.form.classList.remove(classes.wiggle)

      void this.form.offsetWidth

      this.form.classList.add(classes.wiggle)
    }
  }

  handleClickOpen = () => {
    this.props.change(this.props.form, 'agree_null_cid', false)
    this.setState({ open: true, checkedA: false })
  }

  handleClose = () => {
    this.props.change(this.props.form, 'agree_null_cid', false)
    this.setState({ open: false, checkedA: false })
  }

  handleAgree = () => {
    this.props.change(this.props.form, 'agree_null_cid', true)
    this.setState({ open: false, checkedA: true })
  }

  handleChange = event => {
    this.props.change(this.props.form, 'agree_null_cid', event.target.checked)
    this.setState({ checkedA: event.target.checked })
  }

  handleDelete = () => {
    if (
      confirm(
        'Вы действительно хотите отключить модуль CallTrackingBy? При отключении модуля данные о продажах останутся в Google Analytics, а новые данные не будут поступать с момента отключения модуля.'
      )
    ) {
      location.href = '/calltracking/call_tracking_by/delete'
    }
  }

  componentDidMount() {
    this.props.change(
      this.props.form,
      'agree_null_cid',
      this.props.initialValues && this.props.initialValues.agree_null_cid
        ? this.props.initialValues.agree_null_cid
        : false
    )
  }

  render() {
    const {
      classes,
      handleSubmit,
      submitFailed,
      invalid,
      error,
      isFetching,
    } = this.props

    return (
      <React.Fragment>
        <form
          onSubmit={handleSubmit}
          className={cx(
            classes.form,
            { [classes.wiggle]: submitFailed },
            { [classes.novalidate]: invalid }
          )}
          ref={form => (this.form = form)}
        >
          <div className={classes.crmDescriptionSmall}>
            <p>
              Скопируйте ключ: <b>{window.state.settings.user_hash}</b> и добавьте его в настройках call-tracking.by.<br/>
              О том как можно это сделать, читайте <a className={classes.links} href="help/podklyuchenie-calltracking">тут.</a>
            </p>
          </div>
          <div className={classes.sendCid}>
            <Field
              name="agree_null_cid"
              component={renderCheckbox}
              checked={this.state.checkedA}
              onClick={
                this.state.checkedA ? this.handleChange : this.handleClickOpen
              }
            />

            <Typography
              component="p"
              style={{ fontSize: '12px' }}
              variant="body1"
            >
              Отправлять данные по продажам из CRM в Google Analytics с пустым
              ClientID
            </Typography>
          </div>
          {error ? <div className={classes.error}>{error}</div> : ''}
          <ButtonContained
            style={{
              flexShrink: 0,
              fontSize: 16,
              width: '100%',
              height: 48,
              marginBottom: 20,
              padding: 0,
              fontWeight: 700,
              color: '#fff',
            }}
            type="submit"
            color="secondary"
            onClick={() => this.handleClick(classes, submitFailed)}
            text={isFetching ? <Spinner /> : 'Подключить'}
          />

          {window.state.settings.active == 1 ? (
            <ButtonOutlined
              handleClick={this.handleDelete}
              style={{
                width: '100%',
                height: 48,
                padding: 0,
              }}
              color="secondary"
              text="Отключить"
            />
          ) : null}
        </form>
        <Dialog
          open={this.state.open}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              При использовании данной опции данные по продажам с пустым
              ClientID будут передаваться в Google Analytics в канал "прямые
              заходы"
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleAgree} color="primary">
              Ок
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    )
  }
}

const mapDispatchToProps = {
  change,
}

CallTrackingByForm = reduxForm({
  form: 'CallTrackingByForm',
})(connect(null, mapDispatchToProps)(CallTrackingByForm))

export default withStyles(styles)(CallTrackingByForm)
